const CANADA_BOUNDS = {
  south: 41.6,
  north: 83.2,
  west: -141.1,
  east: -52.5,
};

const PROVINCE_BOUNDS = {
  AB: { south: 48.9, north: 60.1, west: -120.1, east: -109.9 },
  BC: { south: 48.2, north: 60.1, west: -139.2, east: -114.0 },
  MB: { south: 48.9, north: 60.1, west: -102.2, east: -88.8 },
  NB: { south: 44.5, north: 48.2, west: -69.1, east: -63.7 },
  NL: { south: 46.5, north: 60.5, west: -67.9, east: -52.5 },
  NS: { south: 43.3, north: 47.1, west: -66.6, east: -59.6 },
  NT: { south: 59.7, north: 78.9, west: -136.6, east: -102.0 },
  NU: { south: 51.5, north: 83.2, west: -121.0, east: -61.0 },
  ON: { south: 41.6, north: 56.9, west: -95.2, east: -74.2 },
  PE: { south: 45.8, north: 47.1, west: -64.6, east: -61.9 },
  QC: { south: 44.8, north: 62.7, west: -79.8, east: -57.1 },
  SK: { south: 48.9, north: 60.1, west: -110.2, east: -101.2 },
  YT: { south: 59.8, north: 69.7, west: -141.2, east: -123.8 },
};

const PROVINCE_ALIASES = {
  ALBERTA: "AB",
  "BRITISH COLUMBIA": "BC",
  MANITOBA: "MB",
  "NEW BRUNSWICK": "NB",
  NEWFOUNDLAND: "NL",
  "NEWFOUNDLAND AND LABRADOR": "NL",
  "NOVA SCOTIA": "NS",
  "NORTHWEST TERRITORIES": "NT",
  NUNAVUT: "NU",
  ONTARIO: "ON",
  "PRINCE EDWARD ISLAND": "PE",
  QUEBEC: "QC",
  SASKATCHEWAN: "SK",
  YUKON: "YT",
};

function normalizeProvinceCode(province) {
  const value = String(province || "").trim().toUpperCase();
  if (!value) return "";
  if (PROVINCE_BOUNDS[value]) return value;
  return PROVINCE_ALIASES[value] || "";
}

function pointIsWithinBounds(point, bounds) {
  const lat = Number(point?.lat);
  const lng = Number(point?.lng);
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= bounds.south &&
    lat <= bounds.north &&
    lng >= bounds.west &&
    lng <= bounds.east
  );
}

function isCoordinateInCanadianFarmRegion(point, province) {
  const provinceCode = normalizeProvinceCode(province);
  const bounds = PROVINCE_BOUNDS[provinceCode] || CANADA_BOUNDS;
  return pointIsWithinBounds(point, bounds);
}

function buildCoordinateRegionDescription(province) {
  const provinceCode = normalizeProvinceCode(province);
  return provinceCode ? `${provinceCode}, Canada` : "Canada";
}

export {
  CANADA_BOUNDS,
  PROVINCE_BOUNDS,
  buildCoordinateRegionDescription,
  isCoordinateInCanadianFarmRegion,
  normalizeProvinceCode,
};
